module.exports = __webpack_public_path__ + "img/keyboard.3f922793.svg";